<template>
<v-row class="login">
 <v-card
    class="mx-auto"
    max-width="500"
  >

    <v-card-title class="text-h6 font-weight-regular justify-space-between">
      <span>{{ currentTitle }}</span>
      <!-- <v-avatar
        color="primary lighten-2"
        class="subheading white--text"
        size="24"
        v-text="step"
      ></v-avatar> -->
    </v-card-title>

    <v-window v-model="step" touchless>

      <v-window-item :value="1">
        <v-card-text>
              <p>برای ورود یا ثبت نام لطفا شماره تلفن همراه خود را وارد کنید</p>
             <v-text-field
            outlined
            v-model="mobile"
            reverse
            :rules="mobileRules"
            max="5"
            type="tel"
            label="شماره تلفن همراه "
            prepend-inner-icon="mdi-cellphone"
          ></v-text-field>
        </v-card-text>
      </v-window-item>

        <v-window-item :value="2">
         
        

        <v-card-text>
              <p>کاربر گرامی لطفا رمز عبور خود را وارد کنید</p>
             <v-text-field
            outlined
            type="password"
           @keydown="verify_checked = false"
:rules="[validate_password]"
reverse
            v-model="password"
            label="رمز عبور"
            prepend-inner-icon="mdi-key-chain"
          ></v-text-field>
        </v-card-text>
      </v-window-item>

        <v-window-item :value="3">
        <v-card-text>
              <p>لطفا کد تایید ارسال شده به تلفن همراه خود را وارد کنید</p>
             <v-text-field
            outlined
            reverse
            type="tel"
            v-model="verify"
            label="کد تایید"
            @keydown="verify_checked = false"
            :rules="[validate_verify]"
            prepend-inner-icon="mdi-cellphone-text"
          ></v-text-field>
        </v-card-text>
      </v-window-item>

     <v-window-item :value="4">

        <v-form autocomplete="off" ref="form" v-model="register_valid">
        <v-card-text>
              <p>برای ثبت نام لطفا اطلاعات زیر را تکمیل کنید</p>
    <v-text-field outlined name="first_name" type="text" v-model="first_name"  :rules="[first_name.length!=0 || 'وارد کردن نام اجباری است']"  autofocus   label="نام" prepend-inner-icon="mdi-account"></v-text-field>
    <v-text-field outlined name="last_name" type="text" v-model="last_name" :rules="[last_name.length!=0 || 'وارد کردن نام خانوادگی اجباری است']" label="نام خانوادگی" prepend-inner-icon="mdi-account-multiple"></v-text-field>
      <!-- <v-text-field autocomplete="off" outlined name="register_password" type="password" counter minlength="6"  :rules="[validate_password]" v-model="register_password" label="رمز عبور" prepend-inner-icon="mdi-map-marker"></v-text-field>
            <v-text-field autocomplete="off" outlined name="register_password_repeat" type="password" counter minlength="6" :rules="[validate_password]"   v-model="register_password_repeat" label="تکرار رمز عبور" prepend-inner-icon="mdi-map-marker"></v-text-field> -->
  
        <v-text-field reverse maxLength="4" @keydown="verify_checked = false" outlined name="verify" type="tel
        "  hint="کد تایید ارسال شده به تلفن همراه خود را وارد کنید" :rules="[validate_verify]"  v-model="verify" label="کد تایید ارسال شده" prepend-inner-icon="mdi-cellphone-text"></v-text-field>

         <v-textarea
         v-model="description"
          outlined
          :rules="[description.length!=0 || 'وارد کردن توضیحات اجباری است']"
          placeholder="توضیحات دو مورد سابقه تعمیرات و تجربه ها"
          label="توضیحات و سابقه تعمیرات"
          value=""
        ></v-textarea>

        </v-card-text>
        </v-form>
      </v-window-item>


      <v-window-item :value="5">
        <v-card-text>
               <div class="succeed">
                  <v-icon  x-large color="white">  mdi-check </v-icon>

            </div>
              <p style="text-align:center">کاربر گرامی {{this.first_name}} {{this.last_name}} شما با موفقیت وارد حساب کاربری شدید</p>
                 <v-btn @click="$router.go()"  depressed color="primary" large class="w100">
    حساب کاربری
  </v-btn>
  </v-card-text>
      </v-window-item>

      <v-window-item :value="6">
        <v-card-text>
            <div class="succeed">
                  <v-icon  x-large color="white">  mdi-check </v-icon>

            </div>
              <p style="text-align:center">کاربر گرامی {{this.first_name}} {{this.last_name}}  ثبت نام شما با موفقیت انجام شد 
<br>
                حساب کاربری شما بعد از تایید ادمین فعال میشود و از طریق پیامک اطلاع رسانی می گردد.
              </p>

                 <!-- <v-btn @click="$router.go()"  depressed color="primary" large class="w100">
    حساب کاربری
  </v-btn> -->
  </v-card-text>
      </v-window-item>
      <v-window-item :value="7">
        <v-card-text>
           
              <p>کاربر گرامی حساب کاربری شما در حال حاضر غیر فعال است

                حساب کاربری شما بعد از تایید ادمین فعال میشود و از طریق پیامک اطلاع رسانی می گردد.
              </p>

                 <!-- <v-btn @click="$router.go()"  depressed color="primary" large class="w100">
    حساب کاربری
  </v-btn> -->
  </v-card-text>
      </v-window-item>

    </v-window>


  </v-card>
  <v-footer
 fixed
   elevation="10"
      bottom
      style="padding: 5px 0;"
      color="white"
      
    >
    <v-row class="w100" style="margin: -10px 0;">
<v-col sm="6">
    <v-btn v-if="step==2 || step==3" @click="step=1" depressed  large  class="w100">
    تغییر شماره تلفن همراه
  </v-btn>
</v-col>
<v-col sm="6">


      <v-btn v-if="step == 1"  @click="send_mobile()" :disabled="!(new RegExp('^(\\+98|0)?9\\d{9}$').test(mobile)) && !(new RegExp('^(\\+98|0)?9\\d{9}$').test(mobile.replace('admin','')))" :loading="loading" depressed color="primary" large class="w100">
    تایید
  </v-btn>
    <v-btn v-if="step == 2" :disabled="password.length == 0" @click="login('by_password')" :loading="loading"  depressed color="primary" large class="w100">
    تایید
  </v-btn>
    <v-btn v-if="step == 3" :disabled="verify.length != 4" @click="login('by_sms')" :loading="loading"  depressed color="primary" large class="w100">
    تایید
  </v-btn>
    <v-btn v-if="step == 4"  @click="register()" :disabled="!register_valid" :loading="loading" depressed color="primary" large class="w100">
    ثبت نام
  </v-btn>


  

</v-col>
    </v-row>
 
        <v-spacer></v-spacer>
  
  </v-footer>
</v-row>
</template>

<script>
  export default {
    name: 'Login',
 computed: {
      currentTitle () {
        switch (this.step) {
          case 1: return 'شماره تلفن همراه '
          case 2: return 'ورود به حساب کاربری'
          case 3: return 'ورود با کد تایید'
          case 4: return 'ثبت نام'
          case 5: return 'ورود موفق'
          case 6: return 'ثبت نام موفق'
          case 7: return 'حساب کاربری غیر فعال'
          default: return 'Account created'
        }
      },
    },
   methods: {

      register(){
        const _this = this
   this.loading = true
    var senddata = {  data:  {mobile:this.mobile,code:this.verify} , actions: ['smscode_get'] };
     this.api_get(senddata).then(data => {
      console.log(data)
if(data.data.length > 0){

  var senddata = {  data: {  data: ['insert', 'agents',{mobile:this.mobile,first_name:this.first_name,last_name:this.last_name,description:this.description},{login:true}] }, actions: ['insert'] };
     this.api_get(senddata).then(function (data) {
  _this.step = 6
  console.log(data)
        //  var session = data.data['session']

//                   var senddata = {data: {  data: ['select', 'agents', '*',{session:data.data['session']}] }, actions: ['get'] };
//     _this.api_get(senddata).then(data => {
// if(data.data.length > 0){
//   _this.$store.state.is_login = true
//    _this.$store.state.user = data.data[0]

//   _this.$cookie.set('session', session, 1);
//          _this.loading = false
//     _this.step = 6

// }
//      })

       
     })

}else{
    _this.loading = false
      _this.verify_checked = true
  _this.verify = '';
  _this.password = '';

}
     }).catch(data => {
 console.log(data)
})
      },

        login(types){
        const _this = this
   this.loading = true
    var senddata = {  data:  {mobile:this.mobile,password:this.password,code:this.verify,type:types} , actions: ['login'] };
     this.api_get(senddata).then(data => {
       console.log(data)
if(data.data.length > 0){

if(data.data[0]['active'] != '0' ){


  var session = data.data[0]['session']
       
          var senddata = {data: {  data: ['select', 'agents', '*',{session:data.data[0]['session']}] }, actions: ['get'] };
    this.api_get(senddata).then(user => {
      console.log()
if(user.data.length > 0){
  _this.$store.state.is_login = true
   _this.$store.state.user = user.data[0]

  _this.$cookie.set('session', session, 1);
         _this.loading = false
    _this.step = 5

}else{
    _this.loading = false
      _this.verify_checked = true
  _this.verify = '';
}
     })


}else{
  
_this.step = 7


}
     


     


}else{
    _this.loading = false
      _this.verify_checked = true
  _this.verify = '';
  _this.password = '';
}
     }).catch(data => {
 console.log(data)
})
      },

  send_mobile(){
    this.loading = true
    
     var senddata = {data:{mobile:this.mobile},actions:['check_mobile']};
    //  var senddata = {  data: {  data: ['select', 'agents', ['id','password'],{mobile:this.mobile}] }, actions: ['get'] };
     this.api_get(senddata).then(data => {
       console.log(data)
         this.loading = false
if(data.data.length > 0){
  if(data.data[0]['password'].length > 0){
 this.step = 2
  }else{
     this.step = 3
      senddata = {  data: {mobile:this.mobile} , actions: ['smscode'] };
     this.api_get(senddata).then(data => {
console.log(data)
     })

  }
 
}else{
     senddata = {  data: {mobile:this.mobile} , actions: ['smscode'] };
     this.api_get(senddata).then(data => {
console.log(data)
     })
   this.step = 4
}
     }).catch(err => {  console.log(err) });
  },

    validate_verify(v){
      if(this.verify_checked ){return 'کد تایید وارد شده اشتباه است' }
      else if(v.length !=4){ return 'کد تایید 4 رقمی ارسال شده را وارد کنید'}
else{
    return true
  }
  },
      validate_password(v){
      if(this.verify_checked ){return 'رمز عبور وارد شده اشتباه است' }
          else if(v.length ==0){ return 'لطفا رمز عبور را وارد کنید'}
else{
    return true
  }
  },

  validate_register_password(v){
if(v.length ==0){ return 'رمز عبور اجباری است'}
else if(!new RegExp('^(?=.*[a-z])(?=.*).{6,20}$').test(v)){ return 'رمز عبور باید حداقل 6 کاراکتر و شامل حروف و اعداد باشد.'}
else if(this.register_password_repeat != this.register_password){ return 'رمز عبور و تکرار رمز عبور مطابقت ندارند'}
else{
    return true
  }
  },
   },
    mounted(){
//      var senddata = {  data: {  data: ['select', 'agents', '*'] }, actions: ['get'] };

//      this.api_get(senddata).then(data => {
// console.log(data)
//      }).catch(err => {  console.log(err) });

  },
    data: () => ({
     description : '',
  step: 1,
  register_valid : true,
  mobile:'',
  loading: false,
   mobileRules: [
        // v => !!v || 'Name is required',
        v =>  ((new RegExp('^(\\+98|0)?9\\d{9}$').test(v)) || (v.includes('admin') && new RegExp('^(\\+98|0)?9\\d{9}$').test(v.replace('admin','')))) || 'لطفا شماره همراه معتبر وارد کنید',
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],

      register_password : '',
      //    register_passwordRules: [
      //      v => !!v || 'رمز عبور اجباری است',
      //      v => (v != this.register_password) || 'رمز عبور و تکرار رمز عبور مطابقت ندارند',
      //   v =>  (new RegExp('^(?=.*[a-z])(?=.*).{6,20}$').test(v)) || 'رمز عبور باید حداقل 6 کاراکتر و شامل حروف و اعداد باشد.',
      // ],

register_password_repeat : '',


  verify:'',
  verify_checked:false,
  password:'',
  first_name:'',
  last_name:'',
    }),
  }
</script>
